interface ProductGridConstantsInterface {
  columns: number
  columnsDesktop: number
  columnsMobile: number
  columnsTablet: number
}

interface AppConstantsInterface {
  portalId: string
  productGrid: ProductGridConstantsInterface
  productThumbnailSize: number
}

const appConstants: AppConstantsInterface = {
  portalId: 'pdp-zone-3',
  productGrid: {
    columns: 12,
    columnsDesktop: 3,
    columnsTablet: 4,
    columnsMobile: 12,
  },
  productThumbnailSize: 600,
}

export { appConstants, AppConstantsInterface, ProductGridConstantsInterface }
